import {
    FETCH_AVAILABLE_KPIS,
    FETCH_AVAILABLE_KPIS_SUCCESS,
    FETCH_AVAILABLE_KPIS_FAILED,

    FETCH_NIGHTS_AVAILABLE,
    FETCH_NIGHTS_AVAILABLE_SUCCESS,
    FETCH_NIGHTS_AVAILABLE_FAILED,

    FETCH_KPI_DATA,
    FETCH_KPI_DATA_SUCCESS,
    FETCH_KPI_DATA_FAILED,

    FETCH_S3_KPI_DATA,
    FETCH_S3_KPI_DATA_SUCCESS,
    FETCH_S3_KPI_DATA_FAILED,

    FETCH_TV_KPI_DATA,
    FETCH_TV_KPI_DATA_SUCCESS,
    FETCH_TV_KPI_DATA_FAILED,
    RESET_TV_KPI_DATA,

    GENERATE_SYSTEM_ANNOTATIONS,
    GENERATE_SYSTEM_ANNOTATIONS_SUCCESS,
    GENERATE_SYSTEM_ANNOTATIONS_FAILED,

    GET_KPI_SUMMARY,
    GET_KPI_SUMMARY_SUCCESS,
    GET_KPI_SUMMARY_FAILED,
    GET_ML_KPI_SUMMARY,
    GET_ML_KPI_SUMMARY_SUCCESS,
    GET_ML_KPI_SUMMARY_FAILED,
    FETCH_ANNOTATIONS,
    FETCH_ANNOTATIONS_SUCCESS,
    FETCH_ANNOTATIONS_FAILED,

    FETCH_PATIENTS_RII_SUMMARY,
    FETCH_PATIENTS_RII_SUMMARY_SUCCESS,
    FETCH_PATIENTS_RII_SUMMARY_FAILED,

    DELETE_ANNOTATIONS,

    ADD_NEW_ANNOTATION,
    ADD_NEW_ANNOTATION_SUCCESS,
    ADD_NEW_ANNOTATION_FAILED,

    EDIT_ANNOTATION,
    EDIT_ANNOTATION_SUCCESS,
    EDIT_ANNOTATION_FAILED,

    FETCH_ANNOTATION_CATEGORIES,
    FETCH_ANNOTATION_CATEGORIES_SUCCESS,
    FETCH_ANNOTATION_CATEGORIES_FAILED,

    ADD_ANNOTATION_CATEGORY,
    ADD_ANNOTATION_CATEGORY_SUCCESS,
    ADD_ANNOTATION_CATEGORY_FAILED,

    EDIT_ANNOTATION_CATEGORY,
    EDIT_ANNOTATION_CATEGORY_SUCCESS,
    EDIT_ANNOTATION_CATEGORY_FAILED,

    DELETE_ANNOTATION_CATEGORY,
    DELETE_ANNOTATION_CATEGORY_SUCCESS,
    DELETE_ANNOTATION_CATEGORY_FAILED,

    UPDATE_KPI_PREFERENCE,
    UPDATE_KPI_PREFERENCE_SUCCESS,
    UPDATE_KPI_PREFERENCE_FAILED,


    UPDATE_TRENDVIEW_KPI_PREFERENCE,
    UPDATE_TRENDVIEW_KPI_PREFERENCE_SUCCESS,
    UPDATE_TRENDVIEW_KPI_PREFERENCE_FAILED,

    FETCH_PATIENT_JIRA_CARDS_DATA,
    FETCH_PATIENT_JIRA_CARDS_DATA_SUCCESS,
    FETCH_PATIENT_JIRA_CARDS_DATA_FAILED,
    EDIT_REPORT_VALUES,
    FETCH_ACTIGRAPH,
    FETCH_ACTIGRAPH_SUCCESS,
    FETCH_ACTIGRAPH_FAILED,
} from "constants/ActionTypes";

export const fetch_available_kpis = (payload) => ({
    type: FETCH_AVAILABLE_KPIS,
    payload
})

export const fetch_available_kpis_success = (payload) => ({
    type: FETCH_AVAILABLE_KPIS_SUCCESS,
    payload
})


export const fetch_available_kpis_failed = (error) => ({
    type: FETCH_AVAILABLE_KPIS_FAILED,
    error
})

export const fetch_nights_available = (payload) => ({
    type: FETCH_NIGHTS_AVAILABLE,
    payload
})

export const fetch_nights_available_success = (payload) => ({
    type: FETCH_NIGHTS_AVAILABLE_SUCCESS,
    payload
})


export const fetch_nights_available_failed = (error) => ({
    type: FETCH_NIGHTS_AVAILABLE_FAILED,
    error
})

export const fetch_actigraph = (payload) => ({
    type: FETCH_ACTIGRAPH,
    payload
})

export const fetch_actigraph_success = (payload) => ({
    type: FETCH_ACTIGRAPH_SUCCESS,
    payload
})

export const fetch_actigraph_failed = (error) => ({
    type: FETCH_ACTIGRAPH_FAILED,
    error
})

export const fetch_kpi_data = (payload) => ({
    type: FETCH_KPI_DATA,
    payload
})

export const fetch_kpi_data_success = (payload) => ({
    type: FETCH_KPI_DATA_SUCCESS,
    payload
})

export const fetch_kpi_data_failed = (error) => ({
    type: FETCH_KPI_DATA_FAILED,
    error
})

export const fetch_s3_kpi_data = (payload) => ({
    type: FETCH_S3_KPI_DATA,
    payload
})

export const fetch_s3_kpi_data_success = (payload) => ({
    type: FETCH_S3_KPI_DATA_SUCCESS,
    payload
})

export const fetch_s3_kpi_data_failed = (error) => ({
    type: FETCH_S3_KPI_DATA_FAILED,
    error
})

export const fetch_tv_kpi_data = (payload) => ({
    type: FETCH_TV_KPI_DATA,
    payload
})

export const fetch_tv_kpi_data_success = (payload) => ({
    type: FETCH_TV_KPI_DATA_SUCCESS,
    payload
})

export const fetch_tv_kpi_data_failed = (error) => ({
    type: FETCH_TV_KPI_DATA_FAILED,
    error
})

export const reset_tv_kpi_data = (payload) => {
    return {
        type: RESET_TV_KPI_DATA,
        payload
    }
}


export const generate_system_annotations = (payload) => ({
    type: GENERATE_SYSTEM_ANNOTATIONS,
    payload
})

export const generate_system_annotations_success = (payload) => ({
    type: GENERATE_SYSTEM_ANNOTATIONS_SUCCESS,
    payload
})

export const generate_system_annotations_failed = (error) => ({
    type: GENERATE_SYSTEM_ANNOTATIONS_FAILED,
    error
})

export const get_kpi_summary = (payload) => ({
    type: GET_KPI_SUMMARY,
    payload
})

export const get_kpi_summary_success = (payload) => ({
    type: GET_KPI_SUMMARY_SUCCESS,
    payload
})

export const get_kpi_summary_failed = (error) => ({
    type: GET_KPI_SUMMARY_FAILED,
    error
})

export const get_ml_kpi_summary = (payload) => ({
    type: GET_ML_KPI_SUMMARY,
    payload
})

export const get_ml_kpi_summary_success = (payload) => ({
    type: GET_ML_KPI_SUMMARY_SUCCESS,
    payload
})

export const get_ml_kpi_summary_failed = (error) => ({
    type: GET_ML_KPI_SUMMARY_FAILED,
    error
})

export const fetch_annotations = (payload) => ({
    type: FETCH_ANNOTATIONS,
    payload,
})

export const fetch_annotations_success = (payload) => ({
    type: FETCH_ANNOTATIONS_SUCCESS,
    payload,
})

export const fetch_annotations_failed = (error) => ({
    type: FETCH_ANNOTATIONS_FAILED,
    error,
})

export const fetch_patients_rii_summary = (payload) => {
    return {
        type: FETCH_PATIENTS_RII_SUMMARY,
        payload
    }
}
export const fetch_patients_rii_summary_success = (payload) => {
    return {
        type: FETCH_PATIENTS_RII_SUMMARY_SUCCESS,
        payload
    }
}
export const fetch_patients_rii_summary_failed = (error) => {
    return {
        type: FETCH_PATIENTS_RII_SUMMARY_FAILED,
        error

    }
}

export const delete_annotations = (payload) => ({
    type: DELETE_ANNOTATIONS,
    payload
})

export const add_new_annotation = (payload) => ({
    type: ADD_NEW_ANNOTATION,
    payload,
})

export const add_new_annotation_success = (payload) => ({
    type: ADD_NEW_ANNOTATION_SUCCESS,
    payload,
})

export const add_new_annotation_failed = (error) => ({
    type: ADD_NEW_ANNOTATION_FAILED,
    error,
})

export const edit_annotation = (payload) => ({
    type: EDIT_ANNOTATION,
    payload,
})

export const edit_annotation_success = (payload) => ({
    type: EDIT_ANNOTATION_SUCCESS,
    payload,
})

export const edit_annotation_failed = (error) => ({
    type: EDIT_ANNOTATION_FAILED,
    error,
})

export const fetch_annotation_categories = (payload) => ({
    type: FETCH_ANNOTATION_CATEGORIES,
    payload,
})

export const fetch_annotation_categories_success = (payload) => ({
    type: FETCH_ANNOTATION_CATEGORIES_SUCCESS,
    payload,
})

export const fetch_annotation_categories_failed = (error) => ({
    type: FETCH_ANNOTATION_CATEGORIES_FAILED,
    error,
})

export const add_annotation_category = (payload) => ({
    type: ADD_ANNOTATION_CATEGORY,
    payload,
})

export const add_annotation_category_success = (payload) => ({
    type: ADD_ANNOTATION_CATEGORY_SUCCESS,
    payload,
})

export const add_annotation_category_failed = (error) => ({
    type: ADD_ANNOTATION_CATEGORY_FAILED,
    error,
})

export const edit_annotation_category = (payload) => ({
    type: EDIT_ANNOTATION_CATEGORY,
    payload,
})

export const edit_annotation_category_success = (payload) => ({
    type: EDIT_ANNOTATION_CATEGORY_SUCCESS,
    payload,
})

export const edit_annotation_category_failed = (error) => ({
    type: EDIT_ANNOTATION_CATEGORY_FAILED,
    error,
})

export const delete_annotation_category = (payload) => ({
    type: DELETE_ANNOTATION_CATEGORY,
    payload,
})

export const delete_annotation_category_success = (payload) => ({
    type: DELETE_ANNOTATION_CATEGORY_SUCCESS,
    payload,
})

export const delete_annotation_category_failed = (error) => ({
    type: DELETE_ANNOTATION_CATEGORY_FAILED,
    error,
})

export const update_kpi_preference = payload => {
    return {
        type: UPDATE_KPI_PREFERENCE,
        payload
    };
};
export const update_kpi_preference_success = payload => {
    return {
        type: UPDATE_KPI_PREFERENCE_SUCCESS,
        payload
    };
};
export const update_kpi_preference_failed = error => {
    return {
        type: UPDATE_KPI_PREFERENCE_FAILED,
        error
    };
};

export const update_trendview_kpi_preference = payload => {
    return {
        type: UPDATE_TRENDVIEW_KPI_PREFERENCE,
        payload
    };
};
export const update_trendview_kpi_preference_success = payload => {
    return {
        type: UPDATE_TRENDVIEW_KPI_PREFERENCE_SUCCESS,
        payload
    };
};
export const update_trendview_kpi_preference_failed = error => {
    return {
        type: UPDATE_TRENDVIEW_KPI_PREFERENCE_FAILED,
        error
    };
};

export const fetch_patient_jira_cards_data = (payload) => {
    return {
        type: FETCH_PATIENT_JIRA_CARDS_DATA,
        payload
    };
};
export const fetch_patient_jira_cards_data_success = (payload) => ({
    type: FETCH_PATIENT_JIRA_CARDS_DATA_SUCCESS,
    payload
})
export const fetch_patient_jira_cards_data_failed = (error) => ({
    type: FETCH_PATIENT_JIRA_CARDS_DATA_FAILED,
    error
})
export const edit_report_values = payload => {
    return {
        type: EDIT_REPORT_VALUES,
        payload
    }
}
